import { render, staticRenderFns } from "./RandomCallLobby.vue?vue&type=template&id=18775a08&"
import script from "./RandomCallLobby.vue?vue&type=script&lang=js&"
export * from "./RandomCallLobby.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports